import React from 'react';
import { isSellerOnVacation } from '@helpers/utils/products';
import useProductQuery from '@hooks/product/use-product-query';
import useProductShippingQuery from '@hooks/product/use-product-shipping-query';
import { SellerOnVacationProps } from '@components/molecules/products/product-details/components/seller-on-vacation/seller-on-vacation';
import dynamic from 'next/dynamic';

const SellerOnVacation = dynamic(
  () => import('@components/molecules/products/product-details/components/seller-on-vacation/seller-on-vacation'),
);

const SellerOnVacationWrapper: React.FC<SellerOnVacationProps> = (props) => {
  const { product } = useProductQuery();
  const { productShipping } = useProductShippingQuery();

  if (!isSellerOnVacation(product) || productShipping?.prohibited || product?.sold) {
    return null;
  }

  return <SellerOnVacation {...props} />;
};

export default SellerOnVacationWrapper;
